<organization-top-navbar></organization-top-navbar>
<div class="flex justify-between w-full lg:px-28 py-4 padding-left-1-2rem">
    <button class="gap-2 flex items-center" (click)="(goBack())">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="size-6 stroke-[#0D6EFD]">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
        <p class=" font-medium text-sm text-[#0D6EFD]">{{'PARKIFLY.BACK_BUTTONS.BACK_TO_PARKINGS' | transloco}}</p>
    </button>
    <button class="gap-2 flex items-center" (click)="(goNext())">
        <p class=" font-medium text-sm text-[#0D6EFD]">{{'PARKIFLY.NEXT_BUTTONS.YOUR_DETAILS' | transloco}}</p>
        <svg class="rotate-180 size-6 stroke-[#0D6EFD]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
    </button>
</div>
<div class="Content w-full lg:px-28 px-4 justify-end items-start gap-8  flex xl:flex-row flex-col ">
    <div class="Frame808 flex-col justify-start items-start gap-4 inline-flex w-full">
        <div class="Frame802 self-stretch flex-col justify-start items-start gap-4 flex">
            <div class="text-black text-lg font-bold leading-loose">
                <p>{{"PARKIFLY.ADDITIONAL_SERVICES.TITLE" | transloco }}</p>
            </div>
            @for (service of additionalServicesControls; track service.value.id) {
            @if(_form.enforceMandatoryProduct() &&
            mandatoryServicesIds().includes(service.value.id)) {
            <app-additional-service-option class="w-full" [isEnforced]="true"
                [option]="service"></app-additional-service-option>
            }@else {
            <app-additional-service-option class="w-full" [isEnforced]="false"
                [option]="service"></app-additional-service-option>
            }
            }@empty {
            <p>{{"PARKIFLY.ADDITIONAL_SERVICES.NO_SERVICES_ON_PARKING" | transloco }}</p>
            }
        </div>
    </div>
    <div class="flex-col basis-1/3 w-full">
        <app-summary [isAdditionalServiceStep]="true"></app-summary>
    </div>
</div>